module.exports = __webpack_public_path__ + "static/media/icon-4.258a028d.png";